import StyleguideExample from "./Example/Example.vue";

export default {
	StyleguideExample
};
